import { STG_ENVIRONMENT, PROD_ENVIRONMENT, PROD_HIDDEN_ENVIRONMENT } from 'constants/index';

export const getEnv = () => {
    // eslint-disable-next-line no-undef
    return __ENV__;
};

export const isSTGEnvironment = () => {
    return getEnv() === STG_ENVIRONMENT;
};
export const isProdEnvironment = () => {
    return getEnv() === PROD_ENVIRONMENT || getEnv() === PROD_HIDDEN_ENVIRONMENT;
};

export const isTestingEnvironment = () => typeof process !== 'undefined' && !!process.env?.JEST_WORKER_ID;
